import type { ComputedRef, Ref } from 'vue';

import type { Attachment } from '@stuut/api/models';

export const FileDropzoneKey = Symbol('FileDropzone');

export interface FileDropzoneProviderContext {
  allowedNumAttachments: Ref<number>;
  clearFileAttachments: () => void;
  disabled?: ComputedRef<boolean | undefined>;
  entityId?: Ref<string>;
  entityModel?: Record<string, any>;
  entityName?: string;
  fileAttachments: Ref<Attachment[]>;
  isOverDropZone: Ref<boolean>;
  isSingleUploadLimitReached: Ref<boolean>;
  onFilesAttached: (files: FileList | File[]) => void;
  openFileInput: () => void;
  presignUrlFnName?: string;
  removeFileAttachment: (attachment: Attachment) => void;
  resetFileInput: () => void;
  setupDropZone: (ref: Ref<HTMLDivElement>) => void;
  useDropZoneRef: Ref<HTMLDivElement>;
}
